import { message as antdMessage } from 'antd';
import { useMemo } from 'react';

/**
 * 全局消息提示自定义 Hook
 * 直接暴露 message.error、message.success、message.info、message.warning 方法
 * 页面可直接 message.error('xxx')，无需传 type
 * @returns {Object} { message, contextHolder }
 */
const useAppMessage = () => {
  const [messageApi, contextHolder] = antdMessage.useMessage();

  // 统一封装各类型方法，使用 useMemo 避免重复创建
  const message = useMemo(() => ({
    success: (content, duration, onClose) => messageApi.success({ content, duration, onClose }),
    error: (content, duration, onClose) => messageApi.error({ content, duration, onClose }),
    info: (content, duration, onClose) => messageApi.info({ content, duration, onClose }),
    warning: (content, duration, onClose) => messageApi.warning({ content, duration, onClose }),
    open: messageApi.open, // 保留原生 open 方法
    loading: (content, duration, onClose) => messageApi.loading({ content, duration, onClose }),
    destroy: messageApi.destroy,
  }), [messageApi]);

  return { message, contextHolder };
};

export default useAppMessage; 